import * as React from "react";
import { css } from "emotion";
import Card from "./Card";

interface TextCardProps {
  text: string;
}
class TextCard extends React.Component<TextCardProps> {
  render() {
    return (
      <Card>
        <div
          lang="en"
          className={css`
            word-break: break-all;
            hyphens: manual;
            height: 100%;
            width: 100%;
          `}
        >
          {this.props.text}
        </div>
      </Card>
    );
  }
}

export default TextCard;
